import { render, staticRenderFns } from "./TaskListTooltip.vue?vue&type=template&id=712e56c1&scoped=true"
import script from "./TaskListTooltip.vue?vue&type=script&lang=js"
export * from "./TaskListTooltip.vue?vue&type=script&lang=js"
import style0 from "./TaskListTooltip.vue?vue&type=style&index=0&id=712e56c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712e56c1",
  null
  
)

export default component.exports